export const formatToPercentage = (
  number: number
): string => {
  const localeBcp47 = "en-GB"
  return new Intl.NumberFormat(localeBcp47, {
    minimumFractionDigits: 2,
    style: "percent",
  }).format(number)
}
